import { Button, Stack } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import { comparer } from 'mobx'
import { observer } from 'mobx-react'
import React, { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import FormField from '../../../../components/Form/FormField'
import { getImageSrc } from '../../../../helpers/getImageSrc'
import { isOperator } from '../../../../services/AccountService'
import WarningPaper from '../Drawers/CreateServiceDrawer/WarningPaper'
import ContentTitle from './components/ContentTitle'
import DrawerHeader from './components/DrawerHeader'
import { defaultValues, resolver } from './consts/searchDrawer.consts'
import { contentWrapperSx } from './consts/styles.consts'
import { createServiceRequestStore } from './stores/NewCreateServiceRequestStore'
import { SearchFormType } from './types/NewDrawers.types'

interface NewSearchRequestDrawerProps {}

const NewSearchRequestDrawer: FC<NewSearchRequestDrawerProps> = ({}) => {
  const {
    isDrawerOpen,
    setIsDrawerOpen,
    setSearchParams,
    setIsResultsDrawerOpen,
    searchParams,
    resetAll,
    setResetAll,
  } = createServiceRequestStore

  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty },
    reset,
  } = useForm<SearchFormType>({
    mode: 'onChange',
    defaultValues,
    resolver,
  })

  const onSubmit = (data: SearchFormType) => {
    setSearchParams(data)
    setIsDrawerOpen(false)
    setIsResultsDrawerOpen(true)
  }

  const onReset = () => reset(defaultValues)
  const onClose = () => {
    setIsDrawerOpen(false)
    onReset()
    setResetAll()
  }

  useEffect(() => {
    if (comparer.structural(searchParams, {}) || resetAll) {
      onReset()
    }
  }, [searchParams, resetAll])

  return (
    <Drawer
      anchor={'right'}
      open={isDrawerOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 380,
        },
      }}
    >
      <DrawerHeader
        title={`Заявка на ${!isOperator() ? 'обслуживание' : 'ремонт'}`}
        onClose={onClose}
      />
      <Stack
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        sx={{ ...contentWrapperSx, paddingX: '16px' }}
        spacing={'14px'}
        justifyContent={'space-between'}
      >
        <Stack spacing={'14px'}>
          <ContentTitle title='Шаг 1. Поиск оборудования' />
          <FormField
            control={control}
            name='equipmentId'
            fullWidth
            onlyNumbers
            label='Номер оборудования'
            inputProps={{
              maxLength: 14,
            }}
          />
          <FormField
            control={control}
            name='phoneNumber'
            fullWidth
            label='Телефон'
            mask={'+7 (999)-999-99-99'}
          />
          <WarningPaper
            title={'Внимание!'}
            text1={
              'Перед заведением заявки на сервисное обслуживание выполните поиск Абонента по одному или нескольким полям, которые вводятся в систему при выполнении заявки на установку'
            }
            text2={null}
            style={{
              paddingX: '16px',
            }}
            list={['ID оборудования', 'Телефон'] as never[]}
          />
        </Stack>
        <Stack spacing={'14px'}>
          <Button type='submit' disabled={!isValid} variant='contained'>
            <img
              alt={'Поиск'}
              src={getImageSrc('search-white')}
              style={{ marginRight: '4px' }}
            />
            Найти данные
          </Button>
          <Button
            type='reset'
            disabled={!isDirty}
            variant='outlined'
            onClick={onReset}
          >
            Сбросить настройки
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  )
}

export default observer(NewSearchRequestDrawer)
